/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import React from "react"
import CartContextProvider from "./src/context/CartContext"
import CollapseContextProvider from "./src/context/CollapseContext"
import LocationContext from "./src/context/LocationContext"
import ContactContext from "./src/context/ContactContext"
require("typeface-marcellus")

export const wrapRootElement = ({ element }) => (
  <CartContextProvider>
    <LocationContext>
      <ContactContext>
        <CollapseContextProvider>{element}</CollapseContextProvider>
      </ContactContext>
    </LocationContext>
  </CartContextProvider>
)
